import { ITableState } from "./tableReducer";

const initialState: ITableState = {
  columns: [],
};

export default initialState;
